<template>
  <div class="enterprise-network_page__wrapper" v-loading="isLoading">
    <enterprise-network-page-header title="New Partner Application" show-right-text/>
    <enterprise-network-company-detail-info-edit ref="companyDetailInfoEdit" is-senior-editor/>
    <enterprise-network-select-country-and-region-edit
      ref="selectCountryAndRegionEdit"
      is-senior-editor
      :default-country="$store.state.user.country"
      @changeCountry="handleChangeCountry"
    />
    <enterprise-network-main-contact-edit ref="mainContactEdit" is-senior-editor :partner-type="partnerType"/>
    <enterprise-network-other-contacts-edit ref="otherContactsEdit" is-senior-editor/>
    <enterprise-network-partner-contract-info-edit
      ref="partnerContractInfoEdit"
      :partner-mode-type="partnerModeType"
      :partner-type="partnerType"
      is-senior-editor
      :is-apply="isApply"
      @changePartnerType="handleChangePartnerType"
      @changeContractExpiryDate="handleChangeContractExpiryDate"
    />
    <enterprise-network-target-information-edit
      ref="targetInformationEdit"
      v-if="partnerType!=='RCP'"
      is-senior-editor
      :partner-type="partnerType"
      :contractExpiryYear="contractExpiryYear"
    />
    <enterprise-network-support-document-edit
      ref="supportDocumentEdit"
      :country="country"
      is-senior-editor
      :is-file-required="partnerType!=='RCP'"
      :is-show-file-down="isShowFileDown"
      :partner-type="partnerType"
    />
    <enterprise-network-footer-tips :is-rcp="isRcp"/>

    <enterprise-network-footer-button
      is-apply
      @cancel="handleCancel"
      @submit="handleSubmitOfIsSale"
    />
    <enterprise-network-reconfirm
      :mainContact="mainContact"
      :visible.sync="reConfirmVisible"
      @confirm="handleSubmit"
      :loading="isLoading"
    />
  </div>
</template>

<script>
import EnterpriseNetworkCompanyDetailInfoEdit from "../components/companyDetailInfo/companyDetailInfoEdit.vue";
import EnterpriseNetworkSelectCountryAndRegionEdit
  from "../components/selectCountryAddRegion/selectCountryAddRegionEdit.vue";
import EnterpriseNetworkMainContactEdit from "../components/mainContact/mainContactEdit.vue";
import EnterpriseNetworkOtherContactsEdit from "../components/otherContacts/otherContactsEdit.vue";
import EnterpriseNetworkPartnerContractInfoEdit from "../components/partnerContractInfo/partnerContractInfoEdit.vue";
import EnterpriseNetworkTargetInformationEdit from "../components/targetInformation/targetInformationEdit.vue";
import dayjs from "dayjs";
import EnterpriseNetworkSupportDocumentEdit from "../components/supportDocument/supportDocumentEdit.vue";
import EnterpriseNetworkFooterTips from "../components/footerTips.vue";
import EnterpriseNetworkFooterButton from "../components/footerButton.vue";
import {createContractEBGorCBGorTBU} from "../../../api/international";
import EnterpriseNetworkPageHeader from "../components/pageHeader.vue";
import EnterpriseNetworkReconfirm from "../components/reconfirm.vue";

export default {
  components: {
    EnterpriseNetworkReconfirm,
    EnterpriseNetworkCompanyDetailInfoEdit,
    EnterpriseNetworkSelectCountryAndRegionEdit,
    EnterpriseNetworkMainContactEdit,
    EnterpriseNetworkOtherContactsEdit,
    EnterpriseNetworkPartnerContractInfoEdit,
    EnterpriseNetworkTargetInformationEdit,
    EnterpriseNetworkSupportDocumentEdit,
    EnterpriseNetworkFooterTips,
    EnterpriseNetworkFooterButton,
    EnterpriseNetworkPageHeader
  },
  props: {
    partnerModeType: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      mainPagePadding: 0,
      country: "",
      partnerType: "",
      contractExpiryYear: "",
      isLoading: false,
      mainContact: null,
      reConfirmVisible: false,
      isApply:true,
    }
  },
  computed: {
    isShowFileDown() {
      return !!this.country && !!this.partnerType
    },
    isRcp() {
      return this.partnerType === 'RCP'
    }
  },
  methods: {
    resetMainPagePadding() {
      let pageDom = document.getElementsByClassName("mainpage")[0];
      this.mainPagePadding = pageDom.style.padding;
      pageDom.style.padding = 0;
      pageDom = null;
    },
    restoreMainPagePadding() {
      let pageDom = document.getElementsByClassName("mainpage")[0];
      pageDom.style.padding = this.mainPagePadding;
      pageDom = null;
    },
    handleScrollToRef(type) {
      let contentDom = document.getElementsByClassName("mainpage")[0];
      contentDom.scrollTo({
        top: this.$refs[type].$el.offsetTop
      });
      contentDom = null;
    },
    handleChangeCountry(country) {
      this.country = country;
    },
    handleChangePartnerType(partnerType) {
      this.partnerType = partnerType;
      
    },
    handleChangeContractExpiryDate(contractExpiryDate) {
      this.contractExpiryYear = contractExpiryDate
        ? dayjs(contractExpiryDate).format("YYYY")
        : "";
    },
    constructParams() {
      const companyDetailInfo = this.$refs["companyDetailInfoEdit"].getFormData();
      const selectCountryAndRegion = this.$refs["selectCountryAndRegionEdit"].getFormData();
      const mainContact = this.$refs["mainContactEdit"].getFormData();
      const otherContacts = this.$refs["otherContactsEdit"].getFormData();
      const partnerContractInfo = this.$refs["partnerContractInfoEdit"].getFormData();
      // 如果是RCP 直接返回空对象
      const salesTargetInformation = this.isRcp ? {} : this.$refs["targetInformationEdit"].getFormData();
      const supportDocument = this.$refs["supportDocumentEdit"].getFormData();

      if (!companyDetailInfo) {
        this.handleScrollToRef("companyDetailInfoEdit");
        return false;
      } else if (!selectCountryAndRegion) {
        this.handleScrollToRef("selectCountryAndRegionEdit");
        return false;
      } else if (!mainContact) {
        this.handleScrollToRef("mainContactEdit");
        return false;
      } else if (!otherContacts) {
        this.handleScrollToRef("otherContactsEdit");
        return false;
      } else if (!partnerContractInfo) {
        this.handleScrollToRef("partnerContractInfoEdit");
        return false;
      } else if (!salesTargetInformation && !this.isRcp) {
        this.handleScrollToRef("targetInformationEdit");
        return false;
      } else if (!supportDocument) {
        this.handleScrollToRef("supportDocumentEdit");
        return false;
      }

      return {
        ...companyDetailInfo,
        ...selectCountryAndRegion,
        ...partnerContractInfo,
        ...salesTargetInformation,
        ...supportDocument,
        masterAccount: this.getMainContactEmail(mainContact.email),
        linkMans: [
          {
            ...mainContact,
            userStatus: 1
          },
          ...otherContacts
        ]
      };

    },
    //RCP特殊email处理
    getMainContactEmail(email){
      if(this.$route.query.partnertype=="RCP"){
        let value=this.$store.state.user.isSale? email :this.$store.state.user.isCommon?this.$store.state.user.businessEmail:email
        return value;
      }else{
        return email;
      }
    },
    //此处为2024-05-13与PM确认后 确定！！ RCP下, 普通用户不需要二次提交！！直接调接口      销售需要二次提交
    handleSubmitOfIsSale() {
      if (this.isRcp) {
        if (this.$store.state.user.isSale) {
          this.handleOpenReConfirm();
        } else {
          this.handleSubmit();
        }
      } else {
        this.handleOpenReConfirm();
      }
    },
    handleOpenReConfirm() {
      let params = this.constructParams();
      if (!params) return;
      this.mainContact = this.$refs.mainContactEdit.getFormData();
      this.reConfirmVisible = true
    },
    handleSubmit() {
      let params = this.constructParams();
      if (!params) return;
      this.isLoading = true;
      createContractEBGorCBGorTBU(params).then(response => {
        let {status, data} = response;
        if (Number(status) === 200) {
          this.$message.success(`Application successful.`);
          // 跳转到申请成功的页面
          this.$router.push({
            path: "/net-service-apply-success",
            query: {
              documentId: data
            }
          })
        }
      }).finally(() => {
        this.isLoading = false;
      })
    },
    handleCancel() {
      this.$router.back();
    },
  },
  mounted() {
    // 刷新获取ref失败 nextTick也不行 
    setTimeout(()=>{
      this.resetMainPagePadding()
      this.$refs['partnerContractInfoEdit'].setContractValidity()
      this.$route.query.partnertype && this.$refs.partnerContractInfoEdit.handleChangePartnerType(this.$route.query.partnertype)
    },0)

  },
  beforeDestroy() {
    this.restoreMainPagePadding()
  }
}
</script>

<style scoped>
@import url("../index.css");
</style>



// WEBPACK FOOTER //
// src/views/enterpriseNetwork/apply/index.vue